(() => {
  const popup = document.querySelector('[data-hydros-promo]');
  const version = popup?.dataset.version || 'hydros-club-v1';
  const keys = { dismissed: `hydros:club:${version}:dismissed`, subscribed: `hydros:club:${version}:subscribed` };
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
  const track = (action, source) => {
    const detail = { action, source, page: location.pathname };
    window.dispatchEvent(new CustomEvent('hydros:newsletter', { detail }));
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: `hydros_newsletter_${action}`, hydros_newsletter: detail });
    }
  };
  document.querySelectorAll('form.hydros-club__form, form[data-hydros-newsletter-form]').forEach(form => {
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      track('submit', form.dataset.newsletterSource || 'club');
      form.setAttribute('aria-busy', 'true');
    });
  });
  document.querySelectorAll('[data-newsletter-result="success"]').forEach(result => {
    write(keys.subscribed, 'true');
    track('success', result.dataset.newsletterSource || 'footer');
  });
  if (!popup) return;
  const excluded = (popup.dataset.excludedPaths || '').split(/[\n,]+/).map(path => path.trim()).filter(Boolean);
  if (excluded.some(path => location.pathname.startsWith(path))) return;
  const dialog = popup.querySelector('[data-hydros-promo-dialog]');
  const invite = popup.querySelector('[data-hydros-promo-invite]');
  if (!dialog || !invite) return;
  const mobile = matchMedia('(max-width: 749px)').matches;
  const days = Number(mobile ? popup.dataset.memoryDaysMobile : popup.dataset.memoryDays) || 14;
  const delay = Math.max(45000, Number(popup.dataset.delay) || 0);
  const depth = Number(popup.dataset.scroll) || 35;
  const began = Date.now();
  let opened = false;
  let dismissed = false;
  let trigger = null;
  let timer;
  let frame;
  const recentlyDismissed = () => Date.now() - Number(read(keys.dismissed) || 0) < days * 86400000;
  const busy = () => document.hidden || [...document.querySelectorAll('cart-drawer.active, [role="alertdialog"], [role="dialog"]:not(.hydros-club__dialog), dialog[open]:not(.hydros-club__dialog)')].some(element => element.getClientRects().length > 0) || document.activeElement?.matches('input, textarea, select');
  const eligible = () => {
    const height = document.documentElement.scrollHeight - innerHeight;
    return height > 0 && scrollY / height * 100 >= depth && Date.now() - began >= delay;
  };
  const concealInvite = () => { invite.hidden = true; };
  const stop = () => {
    clearTimeout(timer);
    cancelAnimationFrame(frame);
    removeEventListener('scroll', onScroll);
    document.removeEventListener('visibilitychange', consider);
  };
  const consider = () => {
    if (opened || dismissed || recentlyDismissed() || read(keys.subscribed) === 'true') { concealInvite(); stop(); return; }
    if (popup.dataset.teaserEnabled !== 'true' || (mobile && popup.dataset.teaserMobile !== 'true')) return;
    if (busy()) { concealInvite(); clearTimeout(timer); timer = setTimeout(consider, 2000); return; }
    if (!eligible()) return;
    if (invite.hidden) { invite.hidden = false; track('invite_view', 'invite'); }
  };
  const onScroll = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(consider); };
  const dismiss = ({ remember = true, restore = true } = {}) => {
    if (remember) { dismissed = true; write(keys.dismissed, String(Date.now())); }
    concealInvite();
    const wasOpen = dialog.open;
    if (wasOpen) dialog.close();
    if (remember) stop();
    if (restore && wasOpen && trigger?.isConnected) trigger.focus({ preventScroll: true });
  };
  const show = source => {
    concealInvite();
    stop();
    opened = true;
    trigger = document.activeElement;
    if (!dialog.open) dialog.show();
    dialog.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    track('view', source);
  };
  popup.hidden = false;
  document.addEventListener('click', event => {
    if (event.target.closest('[data-hydros-club-open], [data-hydros-promo-teaser]')) { event.preventDefault(); show('voluntary'); }
    else if (event.target.closest('[data-hydros-promo-close], [data-hydros-promo-invite-close]')) { dismiss(); track('close', 'club'); }
    else if (dialog.open && !dialog.contains(event.target)) dismiss({ restore: false });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && (dialog.open || !invite.hidden)) { event.preventDefault(); dismiss(); }
  });
  document.addEventListener('focusin', () => { if (!dialog.open && busy()) concealInvite(); });
  const observer = new MutationObserver(() => {
    if (document.querySelector('cart-drawer.active')) dismiss({ remember: false, restore: false });
  });
  const drawer = document.querySelector('cart-drawer');
  if (drawer) observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  addEventListener('pagehide', () => { stop(); observer.disconnect(); }, { once: true });
  addEventListener('pageshow', () => document.querySelectorAll('form[aria-busy="true"]').forEach(form => form.removeAttribute('aria-busy')));
  const result = popup.querySelector('[data-newsletter-result]');
  if (result || new URLSearchParams(location.search).get('hydros_club') === 'preview') { show('return'); return; }
  timer = setTimeout(consider, delay);
  addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('visibilitychange', consider);
})();
